import { useEffect, useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SELLER_STORIES } from '@/lib/homeData';

export default function SellerStoriesSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % SELLER_STORIES.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, []);

  const activeStory = useMemo(() => SELLER_STORIES[activeIndex], [activeIndex]);

  return (
    <section className="bg-[#f4f7fb] px-6 py-20">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-3xl">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">Seller outcomes</p>
            <h2 className="mt-3 font-sans text-3xl text-slate-900 md:text-4xl">Stories from teams using financing to close better deals</h2>
          </div>

          <div className="flex gap-2">
            {SELLER_STORIES.map((story, idx) => (
              <button
                key={story.id}
                type="button"
                aria-label={`Show ${story.title}`}
                onClick={() => setActiveIndex(idx)}
                className={`h-2.5 w-10 rounded-full transition ${idx === activeIndex ? 'bg-slate-900' : 'bg-slate-300'}`}
              />
            ))}
          </div>
        </div>

        <div className="mt-8 rounded-[2rem] border border-slate-200 bg-white p-6 md:p-8">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeStory.id}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -14 }}
              transition={{ duration: 0.35 }}
            >
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">{activeStory.profile}</p>
              <h3 className="mt-2 font-sans text-2xl text-slate-900">{activeStory.title}</h3>

              <div className="mt-6 grid gap-4 md:grid-cols-2">
                <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                  <p className="text-xs uppercase tracking-wide text-slate-500">Before</p>
                  <p className="mt-2 text-sm text-slate-700">{activeStory.before}</p>
                </div>
                <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-4">
                  <p className="text-xs uppercase tracking-wide text-emerald-700">After</p>
                  <p className="mt-2 text-sm text-emerald-900">{activeStory.after}</p>
                </div>
              </div>

              <p className="mt-5 inline-flex rounded-full bg-slate-900 px-3 py-1.5 text-xs font-semibold text-white">{activeStory.highlight}</p>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}
